"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../../../..");
var Typo2_1 = require("../../../../Typo2");
var UI_CAPTION_DF_WITH_LINE_CLAMP = (0, styled_components_1.default)(Typo2_1.UI_CAPTION_DF)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  ", "\n"], ["\n  \n  ", "\n"])), function (_a) {
    var clampT = _a.clampT;
    return clampT ? (0, __1.clampText)(3) : '';
});
var CustomTooltip = function (props) {
    var active = props.active, value = props.value, showPercent = props.showPercent, mousePosition = props.mousePosition;
    var tooltipWrapperRef = (0, react_1.useRef)(null);
    var calcTooltipTop = function (_a) {
        var _b, _c;
        var tooltipWrapperRef = _a.tooltipWrapperRef, mousePosY = _a.mousePosY;
        var windowHeight = window.innerHeight;
        var tooltipWrapperBottom = (_c = (_b = tooltipWrapperRef === null || tooltipWrapperRef === void 0 ? void 0 : tooltipWrapperRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) === null || _c === void 0 ? void 0 : _c.bottom;
        if (tooltipWrapperBottom && tooltipWrapperBottom > windowHeight) {
            var topNegativeOffset = tooltipWrapperBottom - windowHeight;
            return mousePosY - topNegativeOffset - 5; // plus 5 so that the bottom of the tooltip doesnt touch the bottom of the screen
        }
        else {
            return mousePosY;
        }
    };
    // Calculate position - align with the right side of the bars
    var style = {
        position: "fixed",
        left: "".concat((mousePosition === null || mousePosition === void 0 ? void 0 : mousePosition.x) || 0, "px"),
        top: "".concat(calcTooltipTop({ tooltipWrapperRef: tooltipWrapperRef, mousePosY: (mousePosition === null || mousePosition === void 0 ? void 0 : mousePosition.y) || 0 }), "px"),
        transform: "translate(10px, 10px)", // Offset from cursor and center vertically
        backgroundColor: __1.colors2.black,
        color: __1.colors2.white,
        border: "1px solid ".concat(__1.colors2.grey10),
        borderRadius: "6px",
        padding: "8px",
        boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.12)",
        zIndex: 100000,
        width: "max-content",
        maxWidth: "300px",
        maxHeight: "500px",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        // pointerEvents: "none", // Add this to prevent tooltip from interfering with mouse events
    };
    var tooltipLabelLengthRefs = (0, react_1.useRef)([]);
    var _a = (0, react_1.useState)([]), rowHeights = _a[0], setRowHeights = _a[1];
    var _b = (0, react_1.useState)((value === null || value === void 0 ? void 0 : value.map(function (v) { return true; })) || []), tooltipTextClampStates = _b[0], setTooltipTextClampStates = _b[1];
    (0, react_1.useEffect)(function () {
        if (!tooltipTextClampStates) {
            setTooltipTextClampStates(value === null || value === void 0 ? void 0 : value.map(function (v) { return true; }));
        }
    }, [value]);
    (0, react_1.useEffect)(function () {
        // console.log({ tooltipLabelLengthRefs });
        var rowHeightsToSet = tooltipLabelLengthRefs.current.map(function (ref) {
            var _a;
            var heightOfLabelText = (_a = ref === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.height;
            // console.log({heightOfLabelText})
            return heightOfLabelText || null;
        });
        setRowHeights(rowHeightsToSet);
    }, [tooltipTextClampStates.join()]);
    if (!active)
        return null;
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { ref: tooltipWrapperRef, style: style },
            react_1.default.createElement("div", { style: {
                    display: "grid",
                    gridTemplateColumns: showPercent ? "auto auto auto" : "auto auto",
                    gap: "0.6rem",
                } },
                react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "1rem" } }, value.map(function (entry, index) { return (react_1.default.createElement("div", { style: { height: rowHeights[index] ? rowHeights[index] + "px" : "auto" } },
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            alignItems: "center",
                            gap: "0.6rem",
                        } },
                        react_1.default.createElement("div", { key: index, style: {
                                width: "1.2rem",
                                height: "1.2rem",
                                borderRadius: "50%",
                                backgroundColor: entry.color,
                            } }),
                        react_1.default.createElement(Typo2_1.UI_CAPTION_BOLD_DF, { key: index }, showPercent ? entry.percentage + "%" : entry.count || "0")))); })),
                showPercent && (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "1rem" } }, value.map(function (entry, index) { return (react_1.default.createElement("div", { style: {
                        height: rowHeights[index]
                            ? rowHeights[index] + "px"
                            : "auto",
                    } },
                    react_1.default.createElement(Typo2_1.UI_CAPTION_DF, { key: index }, entry.count || "0"))); }))),
                react_1.default.createElement("div", { style: {
                        paddingLeft: "0.8rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                    } }, value.map(function (entry, index) { return (react_1.default.createElement("div", { onMouseOver: function () { return setTooltipTextClampStates(function (prev) {
                        var newState = __spreadArray([], prev, true);
                        newState[index] = false;
                        return newState;
                    }); }, onMouseOut: function () { return setTooltipTextClampStates(function (prev) {
                        var newState = __spreadArray([], prev, true);
                        newState[index] = true;
                        return newState;
                    }); }, ref: function (el) { return (tooltipLabelLengthRefs.current[index] = el); } },
                    react_1.default.createElement(UI_CAPTION_DF_WITH_LINE_CLAMP, { clampT: tooltipTextClampStates[index], key: index }, entry.tooltipLabel))); }))))));
};
exports.default = CustomTooltip;
var templateObject_1;
